import { call, put, select, takeLatest } from 'typed-redux-saga/macro';

import {
  RENAME_DOCUMENT_FAILURE,
  RENAME_DOCUMENT_REQUEST,
  RENAME_DOCUMENT_SUCCESS,
} from '../actions';
import { serviceUpdateTdoName } from '../services';
import { selectSession } from '../selectors';
import { selectToken, selectGraphQLConfig } from './auth';

export function* onRenameDocumentRequest({
  payload: { name, previousName },
}: ReturnType<typeof RENAME_DOCUMENT_REQUEST>) {
  const session = yield* select(selectSession);
  if (!session) {
    return;
  }
  try {
    const token: string = yield* select(selectToken);
    const cfg = yield* select(selectGraphQLConfig);
    // Service returns the server-formatted name (leading whitespace trimmed,
    // etc.) so the slice ends up matching what the TDO actually stores.
    const persisted = yield* call(
      serviceUpdateTdoName,
      session.tdoId,
      name,
      token,
      cfg.apiRoot,
      cfg.graphQLEndpoint,
      cfg.veritoneAppId
    );
    yield* put(RENAME_DOCUMENT_SUCCESS({ name: persisted }));
  } catch (e) {
    const message =
      e instanceof Error ? e.message : 'Failed to rename document';
    console.warn('[documents] rename failed; rolling back.', e);
    yield* put(RENAME_DOCUMENT_FAILURE({ previousName, message }));
  }
}

export function* renameSaga() {
  yield* takeLatest(RENAME_DOCUMENT_REQUEST, onRenameDocumentRequest);
}
